/* Registration form submission to Salesforce */
/*
Forms integrated:
/account/register
*/
var errorMsj = '';
var tradeOptions = null;
$(document).ready(function () {
  if (window.location.toString().indexOf('account/register') != -1) {
    var sRegisterFormNonInterirorDesignerMessage =
      'create_customer_non_interior_designer';
    var sRegisterFormInteriorDesignerMessage =
      'create_customer_interior_designer';

    $('form').attr('id', sRegisterFormNonInterirorDesignerMessage);

    $('#trade-member-checkbox').change(function () {
      if (!this.checked) {
        $('form').attr('id', sRegisterFormNonInterirorDesignerMessage);
      } else {
        $('form').attr('id', sRegisterFormInteriorDesignerMessage);
      }
    });
  }

  /* Submit to salesforvce */
  function submitToSalesforce1() {
    var firstName = $('input#firstnameField').val();
    var lastname = $('input#lastnameField').val();
    var f_email = $('input#emailField').val();
    var f_phone = $('input#phoneField').val();
    var f_country = $('select.country').val();
    var f_state = $('select.state').val();
    var f_zip = $('input#zipField').val();
    var f_company = $('input#companyField').val();
    var sf_landingPage = $('input.landing-page-url').val();
    var sf_keyword = $('input.keyword').val();
    var sf_gclid = $('input.gclid').val();
    var sf_bindId = $('input.bind-id').val();
    var sf_productType = $('input.product-type').val();
    var sf_leadSource = $('input.lead-source').val();
    var sf_campaignId = $('input.campaign-id').val();
    var sf_dclid = $('input.dclid').val();
    var sf_referrerDomain = $('input.referrer-domain').val();
    var sf_campaignContent = $('input.campaign-content').val();
    var sf_leadMedium = $('input.lead-medium').val();
    var sf_trade_pricing = $('input#tradeApproval').val() === 'TRUE' ? 'Yes' : 'No';
    var sf_tax_id = $('input#TaxIdField').val();
    var sf_title = $('input#titleField').val();
    var sf_is_trade_request = $('input#isTradeRequest').val();
    var sf_is_designer = '';
    var sf_comments = $('.contact-body').val();
    var sf_emailMarketing = $('input#optField').val();
    var novobi_form_id = $('input.novobi-form-id').val();

    // Mailchimp Campaign Name
    if (getCookie('ct') != '') {
      sf_leadSource = getCookie('ct');
    }

    // Mailchimp ID for the campaign that generated the link
    if (getCookie('mc_cid') != '') {
      sf_campaignContent = getCookie('mc_cid');
    }

    // unique Mailchimp ID that identifies the recipient’s email address
    if (getCookie('mc_eid') != '') {
      sf_leadMedium = getCookie('mc_eid');
    }

    // Google Campaign info
    if (getCookie('utm_source') != '') {
      sf_leadSource = getCookie('utm_source');
    }

    if (getCookie('utm_campaign') != '') {
      sf_campaignContent = getCookie('utm_campaign');
    }

    if (getCookie('utm_medium') != '') {
      sf_leadMedium = getCookie('utm_medium');
    }

    if ($('#trade-member-checkbox').is(':checked')) {
      sf_is_designer = 'Interior Designer';
      $('form').attr('id', sRegisterFormInteriorDesignerMessage);
    } else {
      sf_is_designer = '';
      $('form').attr('id', sRegisterFormNonInterirorDesignerMessage);
    }

    var formData = {
      oid: '00D700000008Q49',
      retURL: 'https://kb2018.myshopify.com/pages/test-thank-you-page',
      '00N0g000003MsOv': 1,
      '00N0g000003Mrqy': sf_landingPage,
      '00N0g000003Mrr3': sf_keyword,
      '00N0g000003Mrr8': sf_gclid,
      '00N0g000003MrrD': sf_bindId,
      '00N0g000003MrrI': sf_productType,
      '00N70000001lU8u': sf_campaignId,
      '00N0g000003MsFP': sf_dclid,
      '00N0g000003MsFU': sf_referrerDomain,
      '00N0g000003MsFZ': sf_campaignContent,
      '00N0g000003MsFe': sf_leadMedium,
      '00N0g000003MrrN': sf_tax_id,
      '00N0g000003hvkX': sf_trade_pricing,
      '00N0g000003MsHG': 'Registration form',
      '00N0g000003hxzt': sf_is_trade_request,
      '00N0g000003ry0Y': sf_emailMarketing,
      lead_source: sf_leadSource,
      first_name: firstName,
      last_name: lastname,
      email: f_email,
      phone: f_phone,
      state: f_state,
      zip: f_zip,
      country: f_country,
      company: f_company,
      title: sf_title,
      '00N70000001lW9k': sf_is_designer,
      '00N0g000003V6bT': sf_comments
    };

    $.ajax({
      type: 'POST',
      // url: 'https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8',
      url: 'https://kyle-bunting.odoo.com/shopify-form/submit',
      data: formData,
      // success: afterSubmission,
      // error: afterSubmission,
      dataType: 'json',
      crossDomain: true
    });
  }

  if ($('.salesforce-integration .submit-trigger').length) {
    tradeOptions = $('div#trade-member-options');
    /* Checkbox for trade member */
    $('#trade-member-checkbox').click(function () {
      tradeRequestField = $('input#isTradeRequest');
      if ($(this).is(':checked')) {
        tradeRequestField.val('yes');
        tradeOptions.slideDown();
      } else {
        tradeRequestField.val('no');
        tradeOptions.slideUp();
      }
    });
    $('#no-trade').click(function () {
      tradeRequestField = $('input#isTradeRequest');
      if ($(this).is(':checked')) {
        tradeRequestField.val('no');
        tradeOptions.slideUp();
      } else {
        tradeRequestField.val('no');
        tradeOptions.slideDown();
      }
    });

    /* Prevent submission */
    $('.salesforce-integration .submit-trigger').click(function (e) {
      e.preventDefault();
			
      isFormValid = validateForm();
      if (isFormValid) {
        showErrors(false);
        submitToSalesforce1();

        if ($('#trade-member-checkbox').is(':checked')) {
          ga('send', {
            hitType: 'event',
            eventCategory: 'Registration',
            eventAction: 'Successful',
            eventLabel: 'Interior Designer'
          });
        }
      } else {
        showErrors(true);
      }

			$(this).closest('form').submit();
    });
  }

  /* **************** */
  /* Helper functions */
  /* **************** */
  function validateForm() {
    errorMsj =
      'Please fill out the required fields.<br/>Make sure to enter a valid email address.<br>The password must be at least five characters long.<br/><br/>';
    isValid = false;
    emailField = $('form input#emailField').val();
    emailValidation = validateEmail(emailField);
    passwordField = $('form input#passwordField').val().length;
    if (emailValidation && passwordField >= 5) {
      isValid = true;
      if ($('#trade-member-checkbox').is(':checked')) {
        company = $('input#companyField').val() ? true : false;
        title = $('input#titleField').val() ? true : false;
        isValid = false;
        if (company && title) {
          errorMsj = '';
          isValid = true;
          sf_is_designer = 'Interior Designer';
          console.log('Interior Designer : ' + sf_is_designer);
        } else {
          isValid = false;
          errorMsj = errorMsj + '<br/>Please fill out the required fields.';
        }
      }
    }
    return isValid;
  }

  function validateEmail(email) {
    result = false;
    rule = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (rule.test(email)) {
      return true;
    }
    return result;
  }

  function showErrors(show) {
    if (show) {
      $('div#formErrors').html(errorMsj);
    } else {
      $('div#formErrors').html('');
    }
  }

  /* Extend the jQuery object object */
  $.fn.serializeFormJSON = function () {
    var o = {};
    var a = this.serializeArray();
    $.each(a, function () {
      if (o[this.name]) {
        if (!o[this.name].push) {
          o[this.name] = [o[this.name]];
        }
        o[this.name].push(this.value || '');
      } else {
        o[this.name] = this.value || '';
      }
    });
    return o;
  };
});
